import React from "react";

import METHODS from "src/app/pages/CreatorDiscoveryTool/legacy/app/helpers/methods";
import getGenders from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/AudiencesSearch/components/filters/utils/getGenders";
import getSocialProviders from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/AudiencesSearch/components/filters/utils/getSocialProviders";

import {
  SEARCH_FILTER_CONFIGS,
  FILTER_FIELD_NAMES,
  CONTENT_KEYWORD_BLACKLIST,
  removeFilter,
  addFilter,
} from "./utils";
import {
  createArrayFilterLabel,
  createInfluencerFollowersLabel,
  createSubfieldsLabel,
  createSocialProviderLabel,
  createSingleFieldLabel,
} from "./labelCreators";

function SuggestedFilters({
  intl,
  baseFilters,
  suggestedFilters,
  updateBothFilters,
  interests,
}) {
  const genders = getGenders(intl);
  const socialProviders = getSocialProviders(intl);

  const handleActivateFilter = (type, tagProps) => {
    const newBaseFilters = addFilter(
      type,
      tagProps,
      baseFilters,
      suggestedFilters,
    );

    const newSuggestedFilters = removeFilter(type, tagProps, suggestedFilters);

    updateBothFilters(newBaseFilters, newSuggestedFilters);
  };

  const generateLabels = () => {
    let socialProviderIndex = 0;

    const filteredTagNames = SEARCH_FILTER_CONFIGS.filter(
      (tag) =>
        !(
          suggestedFilters.searchContents?.length &&
          CONTENT_KEYWORD_BLACKLIST.includes(tag.name)
        ),
    );

    const labels = filteredTagNames.map((tag, index) => {
      const { name, subfields } = tag;

      // Handle array filters
      if (Array.isArray(suggestedFilters[name])) {
        return suggestedFilters[name].map((subTag, idx) => {
          if (name === FILTER_FIELD_NAMES.INFLUENCER_FOLLOWERS) {
            return createInfluencerFollowersLabel(
              tag,
              subTag,
              idx,
              null,
              handleActivateFilter,
              false,
            );
          }
          return createArrayFilterLabel(
            tag,
            subTag,
            idx,
            null,
            handleActivateFilter,
            interests,
            socialProviders,
            false,
          );
        });
      }

      // Handle subfields
      if (
        tag.subfields &&
        (suggestedFilters[subfields[0]] || suggestedFilters[subfields[1]])
      ) {
        return createSubfieldsLabel(
          tag,
          index,
          suggestedFilters,
          genders,
          null,
          handleActivateFilter,
          false,
        );
      }

      // Handle social provider special case
      if (name === FILTER_FIELD_NAMES.INFLUENCER_SOCIAL_PROVIDER) {
        socialProviderIndex = index;
        return createSocialProviderLabel(
          tag,
          suggestedFilters,
          socialProviders,
          null,
          handleActivateFilter,
          false,
        );
      }

      // Handle single field filters
      if (suggestedFilters[name]) {
        return createSingleFieldLabel(
          tag,
          index,
          suggestedFilters,
          genders,
          null,
          handleActivateFilter,
          false,
        );
      }

      return null;
    });

    const labelsWithSocialProvderAtFirstPlace = METHODS.changeArrayElementOrder(
      labels,
      socialProviderIndex,
      0,
    );
    return labelsWithSocialProvderAtFirstPlace;
  };

  return <>{generateLabels()}</>;
}

export default SuggestedFilters;
